//removeIf(production)
import FloatWithTwoDecimals from "../../domain/entities/float-with-two-decimals";
//removeIf(production)
import ExternalStatus from "../../enums/external-status";
import ClaroluzData from "../../domain/entities/claroluz-data";
import IClaroluzDataDatasource from "../../infra/datasources/i-claroluz-data-datasource";
import ClaroluzBill from "../../domain/entities/claroluz-bill";
import ClaroluzOffer from "../../domain/entities/claroluz-offer";
import ClaroluzPower from "../../domain/entities/claroluz-power";
import ClaroluzEnergy from "../../domain/entities/claroluz-energy";
import ClaroluzTopGas from "../../domain/entities/claroluz-top-gas";
import IClaroluzDatasourceEndpoints from "../../domain/usecases/i-claroluz-datasource-endpoints";
import ClaroluzDatasourceEndpoints from "../../infra/critical/claroluz-datasource-endpoints";
import ClaroluzCupsData from "../../domain/entities/claroluz-cups-data";
//endRemoveIf(production)

class ClaroluzDataDatasourceDev implements IClaroluzDataDatasource {
    url: IClaroluzDatasourceEndpoints;
    result: string;
    type: string;

    constructor(result: string, type: string) {
        this.url = new ClaroluzDatasourceEndpoints({ qr: '', file: '', cups: '', contract: '' });
        this.result = result;
        this.type = type;
    }

    async getOffersByPdf(pdf: string, format: string): Promise<ClaroluzData> {
        return await this.doRequest();
    }
    async getOffersByUrl(url: string): Promise<ClaroluzData> {
        return await this.doRequest();
    }
    async getOffersByCups(data: ClaroluzCupsData): Promise<ClaroluzData> {
        return await this.doRequest();
    }

    private async doRequest(): Promise<ClaroluzData> {
        return new Promise((resolve, reject) => {
            let response: any = {
                "qrResponse": {
                    "cp": "36208",
                    "bs": null,
                    "peaje": null,
                    "pP1": "2.8",
                    "pP2": "2.8",
                    "pP3": null,
                    "pP4": null,
                    "pP5": null,
                    "pP6": null,
                    "caP1": null,
                    "caP2": null,
                    "caP3": null,
                    "caP4": null,
                    "caP5": null,
                    "caP6": null,
                    "iniA": null,
                    "finA": null,
                    "tc": null,
                    "finPen": null,
                    "reg": null,
                    "imp": "52.49",
                    "cfP1": "26",
                    "cfP2": "22",
                    "cfP3": "51",
                    "cfP4": null,
                    "cfP5": null,
                    "cfP6": null,
                    "iniF": "2022-08-03T00:00:00",
                    "finF": "2022-09-02T00:00:00",
                    "impSA": null,
                    "impOtros": null,
                    "exc": null,
                    "com": null,
                    "cups": "ES0022000007781717NE",
                    "pmaxP1": null,
                    "pmaxP2": null,
                    "pmaxP3": null,
                    "pmaxP4": null,
                    "pmaxP5": null,
                    "pmaxP6": null,
                    "totalDays": 30,
                    "electricityFare": "2.0TD",
                    "isQr": true,
                    "hasTopGas": false,
                    "totalTopGasPrice": null,
                    "totalBeforeTopGas": null
                },
                "cupsOffers": [
                    {
                        "productFareName": "2.0TD",
                        "intervalDays": 30,
                        "powerValueP1": 2.8,
                        "powerValueP2": 2.8,
                        "powerValueP3": 0,
                        "powerValueP4": 0,
                        "powerValueP5": 0,
                        "powerValueP6": 0,
                        "powerPriceP1": 0.071682,
                        "powerPriceP2": 0.003132,
                        "powerPriceP3": 0,
                        "powerPriceP4": 0,
                        "powerPriceP5": 0,
                        "powerPriceP6": 0,
                        "roundedPowerTotal": 6.28,
                        "roundedEnergyValueP1": 26,
                        "roundedEnergyValueP2": 22,
                        "roundedEnergyValueP3": 51,
                        "roundedEnergyValueP4": 0,
                        "roundedEnergyValueP5": 0,
                        "roundedEnergyValueP6": 0,
                        "roundedEnergyPriceP1": 0.294507,
                        "roundedEnergyPriceP2": 0.234071,
                        "roundedEnergyPriceP3": 0.210695,
                        "roundedEnergyPriceP4": 0,
                        "roundedEnergyPriceP5": 0,
                        "roundedEnergyPriceP6": 0,
                        "roundedEnergyTotal": 23.55,
                        "roundedElectricalTax": 0.15,
                        "roundedMeasureDeviceRenting": 0.8,
                        "vatValue": 0.05,
                        "roundedTotal": 30.78,
                        "roundedTotalWithVat": 49.01,
                        "offersGreenEnergy": true,
                        "distributorName": " PLENITUDE /ALDRO ",
                        "distributorId": 5,
                        "electricityFareName": "2.0TD",
                        "electricalTaxPercentage": 0.005,
                        "electricityFareId": 26,
                        "totalWithConstants": 39.751963765,
                        "topGas": 16.69
                    },
                    {
                        "productFareName": "2.0TD",
                        "intervalDays": 30,
                        "powerValueP1": 2.8,
                        "powerValueP2": 2.8,
                        "powerValueP3": 0,
                        "powerValueP4": 0,
                        "powerValueP5": 0,
                        "powerValueP6": 0,
                        "powerPriceP1": 0.081045,
                        "powerPriceP2": 0.009228,
                        "powerPriceP3": 0,
                        "powerPriceP4": 0,
                        "powerPriceP5": 0,
                        "powerPriceP6": 0,
                        "roundedPowerTotal": 7.58,
                        "roundedEnergyValueP1": 26,
                        "roundedEnergyValueP2": 22,
                        "roundedEnergyValueP3": 51,
                        "roundedEnergyValueP4": 0,
                        "roundedEnergyValueP5": 0,
                        "roundedEnergyValueP6": 0,
                        "roundedEnergyPriceP1": 0.282416,
                        "roundedEnergyPriceP2": 0.221715,
                        "roundedEnergyPriceP3": 0.199481,
                        "roundedEnergyPriceP4": 0,
                        "roundedEnergyPriceP5": 0,
                        "roundedEnergyPriceP6": 0,
                        "roundedEnergyTotal": 22.39,
                        "roundedElectricalTax": 0.15,
                        "roundedMeasureDeviceRenting": 0.8,
                        "vatValue": 0.05,
                        "roundedTotal": 30.92,
                        "roundedTotalWithVat": 49.16,
                        "offersGreenEnergy": true,
                        "distributorName": "Total",
                        "distributorId": 8,
                        "electricityFareName": "2.0TD",
                        "electricalTaxPercentage": 0.005,
                        "electricityFareId": 26,
                        "totalWithConstants": 39.893109985,
                        "topGas": 16.69
                    },
                    {
                        "productFareName": "2.0TD",
                        "intervalDays": 30,
                        "powerValueP1": 2.8,
                        "powerValueP2": 2.8,
                        "powerValueP3": 0,
                        "powerValueP4": 0,
                        "powerValueP5": 0,
                        "powerValueP6": 0,
                        "powerPriceP1": 0.082641,
                        "powerPriceP2": 0.030529,
                        "powerPriceP3": 0,
                        "powerPriceP4": 0,
                        "powerPriceP5": 0,
                        "powerPriceP6": 0,
                        "roundedPowerTotal": 9.5,
                        "roundedEnergyValueP1": 26,
                        "roundedEnergyValueP2": 22,
                        "roundedEnergyValueP3": 51,
                        "roundedEnergyValueP4": 0,
                        "roundedEnergyValueP5": 0,
                        "roundedEnergyValueP6": 0,
                        "roundedEnergyPriceP1": 0.216866,
                        "roundedEnergyPriceP2": 0.216866,
                        "roundedEnergyPriceP3": 0.216866,
                        "roundedEnergyPriceP4": 0,
                        "roundedEnergyPriceP5": 0,
                        "roundedEnergyPriceP6": 0,
                        "roundedEnergyTotal": 21.47,
                        "roundedElectricalTax": 0.15,
                        "roundedMeasureDeviceRenting": 0.8,
                        "vatValue": 0.05,
                        "roundedTotal": 31.92,
                        "roundedTotalWithVat": 50.21,
                        "offersGreenEnergy": true,
                        "distributorName": " PLENITUDE /ALDRO ",
                        "distributorId": 5,
                        "electricityFareName": "2.0TD",
                        "electricalTaxPercentage": 0.005,
                        "electricityFareId": 26,
                        "totalWithConstants": 40.89715478275,
                        "topGas": 16.69
                    },
                    {
                        "productFareName": "2.0TD",
                        "intervalDays": 30,
                        "powerValueP1": 2.8,
                        "powerValueP2": 2.8,
                        "powerValueP3": 0,
                        "powerValueP4": 0,
                        "powerValueP5": 0,
                        "powerValueP6": 0,
                        "powerPriceP1": 0.0799015,
                        "powerPriceP2": 0.011351,
                        "powerPriceP3": 0,
                        "powerPriceP4": 0,
                        "powerPriceP5": 0,
                        "powerPriceP6": 0,
                        "roundedPowerTotal": 7.67,
                        "roundedEnergyValueP1": 26,
                        "roundedEnergyValueP2": 22,
                        "roundedEnergyValueP3": 51,
                        "roundedEnergyValueP4": 0,
                        "roundedEnergyValueP5": 0,
                        "roundedEnergyValueP6": 0,
                        "roundedEnergyPriceP1": 0.251697,
                        "roundedEnergyPriceP2": 0.251697,
                        "roundedEnergyPriceP3": 0.251697,
                        "roundedEnergyPriceP4": 0,
                        "roundedEnergyPriceP5": 0,
                        "roundedEnergyPriceP6": 0,
                        "roundedEnergyTotal": 24.92,
                        "roundedElectricalTax": 0.16,
                        "roundedMeasureDeviceRenting": 0.8,
                        "vatValue": 0.05,
                        "roundedTotal": 33.55,
                        "roundedTotalWithVat": 51.92,
                        "offersGreenEnergy": true,
                        "distributorName": "Gesternova",
                        "distributorId": 57,
                        "electricityFareName": "2.0TD",
                        "electricalTaxPercentage": 0.005,
                        "electricityFareId": 26,
                        "totalWithConstants": 42.512345005,
                        "topGas": 16.69
                    },
                    {
                        "productFareName": "2.0TD",
                        "intervalDays": 30,
                        "powerValueP1": 2.8,
                        "powerValueP2": 2.8,
                        "powerValueP3": 0,
                        "powerValueP4": 0,
                        "powerValueP5": 0,
                        "powerValueP6": 0,
                        "powerPriceP1": 0.071682,
                        "powerPriceP2": 0.014091,
                        "powerPriceP3": 0,
                        "powerPriceP4": 0,
                        "powerPriceP5": 0,
                        "powerPriceP6": 0,
                        "roundedPowerTotal": 7.21,
                        "roundedEnergyValueP1": 26,
                        "roundedEnergyValueP2": 22,
                        "roundedEnergyValueP3": 51,
                        "roundedEnergyValueP4": 0,
                        "roundedEnergyValueP5": 0,
                        "roundedEnergyValueP6": 0,
                        "roundedEnergyPriceP1": 0.337505,
                        "roundedEnergyPriceP2": 0.267421,
                        "roundedEnergyPriceP3": 0.239372,
                        "roundedEnergyPriceP4": 0,
                        "roundedEnergyPriceP5": 0,
                        "roundedEnergyPriceP6": 0,
                        "roundedEnergyTotal": 26.87,
                        "roundedElectricalTax": 0.17,
                        "roundedMeasureDeviceRenting": 0.8,
                        "vatValue": 0.05,
                        "roundedTotal": 35.05,
                        "roundedTotalWithVat": 53.49,
                        "offersGreenEnergy": true,
                        "distributorName": " PLENITUDE /ALDRO ",
                        "distributorId": 5,
                        "electricityFareName": "2.0TD",
                        "electricalTaxPercentage": 0.005,
                        "electricityFareId": 26,
                        "totalWithConstants": 44.00786842,
                        "topGas": 16.69
                    },
                    {
                        "productFareName": "2.0TD",
                        "intervalDays": 30,
                        "powerValueP1": 2.8,
                        "powerValueP2": 2.8,
                        "powerValueP3": 0,
                        "powerValueP4": 0,
                        "powerValueP5": 0,
                        "powerValueP6": 0,
                        "powerPriceP1": 0.082641,
                        "powerPriceP2": 0.030529,
                        "powerPriceP3": 0,
                        "powerPriceP4": 0,
                        "powerPriceP5": 0,
                        "powerPriceP6": 0,
                        "roundedPowerTotal": 9.5,
                        "roundedEnergyValueP1": 26,
                        "roundedEnergyValueP2": 22,
                        "roundedEnergyValueP3": 51,
                        "roundedEnergyValueP4": 0,
                        "roundedEnergyValueP5": 0,
                        "roundedEnergyValueP6": 0,
                        "roundedEnergyPriceP1": 0.251946,
                        "roundedEnergyPriceP2": 0.251946,
                        "roundedEnergyPriceP3": 0.251946,
                        "roundedEnergyPriceP4": 0,
                        "roundedEnergyPriceP5": 0,
                        "roundedEnergyPriceP6": 0,
                        "roundedEnergyTotal": 24.94,
                        "roundedElectricalTax": 0.17,
                        "roundedMeasureDeviceRenting": 0.8,
                        "vatValue": 0.05,
                        "roundedTotal": 35.41,
                        "roundedTotalWithVat": 53.87,
                        "offersGreenEnergy": true,
                        "distributorName": " PLENITUDE /ALDRO ",
                        "distributorId": 5,
                        "electricityFareName": "2.0TD",
                        "electricalTaxPercentage": 0.005,
                        "electricityFareId": 26,
                        "totalWithConstants": 44.38739461,
                        "topGas": 16.69
                    },
                    {
                        "productFareName": "2.0TD",
                        "intervalDays": 30,
                        "powerValueP1": 2.8,
                        "powerValueP2": 2.8,
                        "powerValueP3": 0,
                        "powerValueP4": 0,
                        "powerValueP5": 0,
                        "powerValueP6": 0,
                        "powerPriceP1": 0.090273,
                        "powerPriceP2": 0.090273,
                        "powerPriceP3": 0,
                        "powerPriceP4": 0,
                        "powerPriceP5": 0,
                        "powerPriceP6": 0,
                        "roundedPowerTotal": 15.17,
                        "roundedEnergyValueP1": 26,
                        "roundedEnergyValueP2": 22,
                        "roundedEnergyValueP3": 51,
                        "roundedEnergyValueP4": 0,
                        "roundedEnergyValueP5": 0,
                        "roundedEnergyValueP6": 0,
                        "roundedEnergyPriceP1": 0.22808,
                        "roundedEnergyPriceP2": 0.22808,
                        "roundedEnergyPriceP3": 0.22808,
                        "roundedEnergyPriceP4": 0,
                        "roundedEnergyPriceP5": 0,
                        "roundedEnergyPriceP6": 0,
                        "roundedEnergyTotal": 22.58,
                        "roundedElectricalTax": 0.19,
                        "roundedMeasureDeviceRenting": 0.8,
                        "vatValue": 0.05,
                        "roundedTotal": 38.74,
                        "roundedTotalWithVat": 57.37,
                        "offersGreenEnergy": true,
                        "distributorName": "Total",
                        "distributorId": 8,
                        "electricityFareName": "2.0TD",
                        "electricalTaxPercentage": 0.005,
                        "electricityFareId": 26,
                        "totalWithConstants": 47.70072886,
                        "topGas": 16.69
                    },
                    {
                        "productFareName": "2.0TD",
                        "intervalDays": 30,
                        "powerValueP1": 2.8,
                        "powerValueP2": 2.8,
                        "powerValueP3": 0,
                        "powerValueP4": 0,
                        "powerValueP5": 0,
                        "powerValueP6": 0,
                        "powerPriceP1": 0.0799015,
                        "powerPriceP2": 0.011351,
                        "powerPriceP3": 0,
                        "powerPriceP4": 0,
                        "powerPriceP5": 0,
                        "powerPriceP6": 0,
                        "roundedPowerTotal": 7.67,
                        "roundedEnergyValueP1": 26,
                        "roundedEnergyValueP2": 22,
                        "roundedEnergyValueP3": 51,
                        "roundedEnergyValueP4": 0,
                        "roundedEnergyValueP5": 0,
                        "roundedEnergyValueP6": 0,
                        "roundedEnergyPriceP1": 25.1577,
                        "roundedEnergyPriceP2": 25.1577,
                        "roundedEnergyPriceP3": 25.1577,
                        "roundedEnergyPriceP4": 0,
                        "roundedEnergyPriceP5": 0,
                        "roundedEnergyPriceP6": 0,
                        "roundedEnergyTotal": 2490.61,
                        "roundedElectricalTax": 12.49,
                        "roundedMeasureDeviceRenting": 0.8,
                        "vatValue": 0.05,
                        "roundedTotal": 2511.57,
                        "roundedTotalWithVat": 2653.84,
                        "offersGreenEnergy": true,
                        "distributorName": "Gesternova",
                        "distributorId": 57,
                        "electricityFareName": "2.0TD",
                        "electricalTaxPercentage": 0.005,
                        "electricityFareId": 26,
                        "totalWithConstants": 2520.53511349,
                        "topGas": 16.69
                    }
                ]
            };

            let bill = new ClaroluzBill({
                cups: response.qrResponse.cups.replace(/\s/g, ''),
                amount: parseFloat(response.qrResponse.imp),
                is2TD: response.qrResponse.electricityFare === "2.0TD",
                isPeninsula: true, // response.qrResponse.cp
                topGas: new ClaroluzTopGas({
                    hasTopGas: false,
                    hasAlert: false,
                    value: 0,
                    offerValue: 0,
                }),
                yearlySave: 0,
            });

            let status = this.result == 'local' ? ExternalStatus.CLAROLUZ_SUCCESS : ExternalStatus.CLAROLUZ_NO_OFFERS;
            let claroluzData = new ClaroluzData(status, bill);

            if (this.result == 'local') {
                let isValidOffer = false;
                let currentValue = bill.amount;

                response.cupsOffers.forEach((cupsOffer: {
                    totalVatValue: number;
                    roundedVatValue: number;
                    description: string;
                    shortDescription: string;
                    priceId: any;
                    roundedTotalWithVat: number;
                    electricityFareName: string;
                    offersGreenEnergy: boolean;
                    powerValueP1: number;
                    powerPriceP1: number;
                    intervalDays: number;
                    powerValueP2: number;
                    powerPriceP2: number;
                    roundedPowerTotal: number;
                    roundedEnergyValueP1: number;
                    roundedEnergyPriceP1: number;
                    roundedEnergyValueP2: number;
                    roundedEnergyPriceP2: number;
                    roundedEnergyValueP3: number;
                    roundedEnergyPriceP3: number;
                    vatValue: number;
                    roundedEnergyTotal: number;
                    roundedElectricalTax: number;
                    electricalTaxPercentage: number;
                    roundedMeasureDeviceRenting: number;
                    roundedTotal: number;
                    topGas: number;
                    environment: string;distributorName: string, distributorId: number
}) => {
                    if (currentValue > cupsOffer.roundedTotalWithVat) {
                        isValidOffer = true;
                        claroluzData.addOffer(new ClaroluzOffer({
                            distributor: cupsOffer.distributorName.toLowerCase().trim(),
                            distributorId: cupsOffer.distributorId,
                            is2TD: cupsOffer.electricityFareName === "2.0TD",
                            offersGreenEnergy: cupsOffer.offersGreenEnergy,
                            power1: new ClaroluzPower({
                                value: cupsOffer.powerValueP1,
                                price: cupsOffer.powerPriceP1,
                                intervalDays: cupsOffer.intervalDays,
                            }),
                            power2: new ClaroluzPower({
                                value: cupsOffer.powerValueP2,
                                price: cupsOffer.powerPriceP2,
                                intervalDays: cupsOffer.intervalDays,
                            }),
                            powerTotal: new ClaroluzPower({
                                value: cupsOffer.roundedPowerTotal,
                                price: 0.0,
                                intervalDays: cupsOffer.intervalDays,
                            }),
                            energy1: new ClaroluzEnergy({
                                value: cupsOffer.roundedEnergyValueP1,
                                price: cupsOffer.roundedEnergyPriceP1
                            }),
                            energy2: cupsOffer.roundedEnergyValueP2 > 0 ? new ClaroluzEnergy({
                                value: cupsOffer.roundedEnergyValueP2,
                                price: cupsOffer.roundedEnergyPriceP2
                            }) : null,
                            energy3: cupsOffer.roundedEnergyValueP3 > 0 ? new ClaroluzEnergy({
                                value: cupsOffer.roundedEnergyValueP3,
                                price: cupsOffer.roundedEnergyPriceP3
                            }) : null,
                            vatValue: cupsOffer.vatValue,
                            roundedVatValue: cupsOffer.roundedVatValue,
                            totalVatValue: cupsOffer.totalVatValue,
                            energyTotal: cupsOffer.roundedEnergyTotal,
                            electricalTax: cupsOffer.roundedElectricalTax,
                            electricalTaxPercentage: cupsOffer.electricalTaxPercentage,
                            measureDeviceRenting: cupsOffer.roundedMeasureDeviceRenting,
                            priceTotal: cupsOffer.roundedTotal,
                            priceTotalWithVat: cupsOffer.roundedTotalWithVat,
                            priceId: parseInt(cupsOffer.priceId),
                            description: cupsOffer.description,
                            shortDescription: cupsOffer.shortDescription,
                        }));

                        if (bill!.topGas.hasTopGas) {
                            bill!.topGas.offerValue = cupsOffer.topGas;
                        }
                    }
                });
            }

            resolve(claroluzData);
        });
    }
}

//removeIf(production)
export default ClaroluzDataDatasourceDev;

function appProperties(): import("../../infra/critical/claroluz-events-properties").default {
    throw new Error("Function not implemented.");
}
//endRemoveIf(production)